import { render, staticRenderFns } from "./Definition.vue?vue&type=template&id=4623fa60&scoped=true"
import script from "./Definition.vue?vue&type=script&lang=js"
export * from "./Definition.vue?vue&type=script&lang=js"
import style0 from "./Definition.vue?vue&type=style&index=0&id=4623fa60&prod&scoped=true&lang=css"
import style1 from "./Definition.vue?vue&type=style&index=1&id=4623fa60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4623fa60",
  null
  
)

export default component.exports